// Shared helpers for multi-quantity modifiers ("2x Chocolate").
//
// Client state stores the UNIT count per option; the wire payload multiplies
// by line qty at the boundary (basketCalculatePayload.js). Selection entries
// come in two shapes: plain option-id strings (flag-off toggle groups — kept
// bit-for-bit as today) and {id, qty} objects (allowquantities groups).
// Basket options and localStorage carts persisted before this feature have no
// qty field, so every reader defaults to 1.

// Unit quantity of a selection entry or basket option.
export const unitQty = (entry) => {
  if (entry == null || typeof entry === 'string') return 1;
  return entry.qty ?? 1;
};

// Option id of a selection entry (string id or {id, qty} object).
export const optionEntryId = (entry) =>
  typeof entry === 'string' ? entry : entry?.id;

// Sum of unit quantities across a group's selection array (Rule 2:
// min/max compare this sum for allowquantities groups).
export const sumUnitQty = (entries = []) =>
  entries.reduce((sum, entry) => sum + unitQty(entry), 0);

// Display rule: unit qty n > 1 renders ASCII prefix "2x Chocolate";
// n == 1 (or missing) renders exactly today's output — no prefix.
export const optionDisplayName = (name, n) => (n > 1 ? `${n}x ${name}` : name);

// Price annotations show EXTENDED amounts: unit price x unit qty.
export const extendedOptionPrice = (price, n) => (price || 0) * (n ?? 1);

// Rule 3: unit quantity of a SERVER order item option. Prefers the API's
// computed `unitquantity`; falls back to deriving it from the total-units
// `quantity` for responses that predate the API deploy:
//   itemQty > 0 && quantity % itemQty == 0 ? quantity / itemQty : quantity
// Legacy rows have quantity == lineQty -> 1 -> no prefix.
export const serverOptionUnitQty = (option, itemQuantity) => {
  if (!option) return 1;
  if (option.unitquantity != null) return option.unitquantity;
  const total = option.quantity;
  if (total == null) return 1;
  if (itemQuantity > 0 && total % itemQuantity === 0) {
    return total / itemQuantity;
  }
  return total;
};
